const demosData = [
  {
    slug: 'cuda-warp-shuffle', 
    path: "cuda-warp-shuffle", 
    title: 'CUDA Warp Shuffle Visualizer',
    description: "Interactive visualization of thread execution and warp-level operations in CUDA programming. Understand how warp shuffles work across 32 threads with mask operations.",
    imageUrl: '/images/demos/warp_visualizer.webp', 
    tags: ['CUDA', 'Parallel Computing', 'GPU', 'Visualization'],
    category: 'Programming',
    date: 'Nov 01, 2025',
    featured: true
  },
  {
    slug: 'cuda-thread-blocks-calculator',
    path: "cuda-thread-blocks-calculator",
    title: 'CUDA Thread Blocks Calculator',
    description: "Visual calculator demonstrating how data is divided into blocks and threads in CUDA. Shows the (N+M-1)/M formula in action with animated block visualization and inactive thread handling.",
    imageUrl: '/images/demos/thread_blocks_visualizer.webp',
    tags: ['CUDA', 'GPU Programming', 'Parallel Computing', 'Visualization', 'Educational'],
    category: 'Programming',
    date: 'Nov 09, 2025',
    featured: true
  },
  {
    slug: 'thread-blocks-best-practices',
    path: "thread-blocks-best-practices",
    title: 'Cuda thread blocks best practices',
    description: "Visuals of best practices of selecting threads and blocks.",
    imageUrl: '/images/demos/thread_block_best_practices.webp',
    tags: ['CUDA', 'GPU Programming', 'Parallel Computing', 'Visualization', 'Educational'],
    category: 'Programming',
    date: 'Nov 17, 2025',
    featured: true
  },
  {
    slug: 'gpu-generations-visualizer',
    path: "gpu-generations-visualizer",
    title: 'The Evolution of NVIDIA GPUs',
    description: "The analysis of NVIDIA's GPU architecture from the Fermi generation (circa 2010) through the current Hopper and Ada Lovelace architectures reveals a fundamental shift from homogeneous, general-purpose parallel processing (GPGPU) toward highly specialized, heterogeneous silicon. This evolution has been predicated on two primary drivers: relentless aggression in semiconductor process node scaling and the strategic introduction of specialized execution units dedicated to artificial intelligence (AI) and real-time ray tracing (RT).",
    imageUrl: '/images/demos/gpu_generations.webp',
    tags: ['Nvidia', 'Parallel Computing', 'Visualization', 'Generations'],
    category: 'Hardware',
    date: 'Nov 21, 2025',
    featured: true
  }
];


const sortedDemosData = demosData.sort((a, b) => {
  const dateA = new Date(a.date);
  const dateB = new Date(b.date);
  return dateB - dateA;
});

module.exports = sortedDemosData;
module.exports.default = sortedDemosData;
